import React from 'react';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { SimpleFlexContainer as FlexContainer } from '../../components/layouts/ng-layouts/Containers';
import styled from 'styled-components';

const Container = styled(FlexContainer)`
  svg {
    opacity: 0.4;
    transition: 0.5s;
  }

  [data-id='up-icon'] {
    ${({ $sort }) => ($sort === 'asc' ? 'opacity: 1;' : '')}
    margin-bottom: -0.5rem;
  }
  [data-id='down-icon'] {
    ${({ $sort }) => ($sort === 'desc' ? 'opacity: 1;' : '')}
    margin-top: -0.5rem;
  }
`;

const SortIcon = ({ sort }) => {
  return (
    <Container $sort={sort}>
      <ArrowDropUpIcon data-id="up-icon" />
      <ArrowDropDownIcon data-id="down-icon" />
    </Container>
  );
};

export default SortIcon;
